// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__nnyn3","question":"Question_question__q6cC7","description":"Question_description__NPvbG"};